import { Pipe, PipeTransform } from '@angular/core';
import { getActivityTitleDetail } from './activity.functions';

@Pipe({
  name: 'activityTitleDetail'
})
export class ActivityTitleDetailPipe implements PipeTransform {
    transform(activity?: any): string {
        return getActivityTitleDetail(activity);
    }
};